export default __webpack_public_path__ + "static/media/nft-20.c8424ca3.png";